import { Controller } from "@hotwired/stimulus";

// A native <details> used as a dropdown (« Déposer un contenu », 2026-10-20): it still opens
// without a script; with it, a click outside or Escape closes it, as a dropdown does.
export default class extends Controller {
  connect() {
    this.outside = (event) => {
      if (this.element.open && !this.element.contains(event.target)) this.element.open = false;
    };
    this.escape = (event) => {
      if (event.key !== "Escape" || !this.element.open) return;

      this.element.open = false;
      this.element.querySelector("summary")?.focus();
    };
    document.addEventListener("click", this.outside);
    document.addEventListener("keydown", this.escape);
  }

  disconnect() {
    document.removeEventListener("click", this.outside);
    document.removeEventListener("keydown", this.escape);
  }
}
